<template>
  <div class="inventory-dashboard">
    <v-row>
      <v-col cols="6" md="8">
        <h1 class="text-left mx-4">Store : {{ store.store_name }} </h1>
      </v-col>
      <v-col cols="6" md="4">
          <v-btn
                v-if="currentUser.privileges.canEditStoreDetails"
                color="primary"
                outlined
                rounded
                small
                :to="{ name: 'EditStore', params: { id: $route.params.store_id } }"
            >
                Edit
                <span class="hidden-sm-and-down ml-1">Store</span>
            </v-btn>
      </v-col>
    </v-row>

    <v-container class="mx-2 my-0">
        <v-row>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ store.code }}</h3>
                <p class="mb-0 text-left">Store Code</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ store.invoice_prefix || "-" }}</h3>
                <p class="mb-0 text-left">Invoice Prefix</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ store.store_type.type_name }}</h3>
                <p class="mb-0 text-left">Store Type</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ store.store_category.category_name }}</h3>
                <p class="mb-0 text-left">Store Category</p>
            </v-col>
        </v-row>
    </v-container>
    
    <v-btn color="primary" v-if="currentUser.privileges.canAddStoreItems" rounded :to="{ name: 'AddStoreItem', params:{ store_id: this.$route.params.store_id } }">Add Item in Store</v-btn>
    
    <v-card class="mx-4 my-4" v-if="currentUser.privileges.canViewAllStoreItems">
        <v-card-title>
            Store Items
            <v-spacer></v-spacer>
            <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            ></v-text-field>
        </v-card-title>

            <!-- filter -->
            <!-- <v-row class="mx-4">
            <v-col cols="12" md="4">
                <v-select
                v-model="filter.category"
                :items="categories"
                small-chips
                outlined
                color="primary"
                label="Filter by Category"
                multiple
                hide-details
                dense
                background-color="transparent"
                item-value="code"
                item-text="code"
                class="mb-4 rounded-input"
                @change="getAllFeeRecords()"
                ></v-select>
            </v-col>

            <v-col cols="12" md="4">
                <v-select
                v-model="filter.room"
                :items="rooms"
                small-chips
                outlined
                color="primary"
                label="Filter by Classroom"
                multiple
                hide-details
                dense
                background-color="transparent"
                item-value="id"
                item-text="sections"
                class="mb-4 rounded-input"
                @change="getAllFeeRecords()"
                ></v-select>
            </v-col>
            <v-col cols="12" md="4">
                <v-select
                v-model="filter.status"
                :items="['Paid', 'Due', 'Overdue', 'Upcoming']"
                small-chips
                outlined
                color="primary"
                label="Filter by Payment Status"
                multiple
                hide-details
                dense
                background-color="transparent"
                class="mb-4 rounded-input"
                @change="getAllFeeRecords()"
                ></v-select>
            </v-col>
            </v-row> -->


            <!-- filter end -->
        <v-data-table
            :headers="store_item_headers"
            :items="store_items"
            :items-per-page="15"
            class="row-pointer"
            @click:row="clickStoreItemRow"
        >
            <template v-slot:item.arrived_on="{item}">
                {{ item.arrived_on? moment(item.arrived_on).format("DD MMM, YYYY") : "-" }}
            </template>
            <template v-slot:item.unit_price="{item}">
                {{ item.unit_price? currencyFormat(item.unit_price): "-" }}
            </template>

        </v-data-table>
    </v-card>
    
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import api from "@api/index";
import { mapActions, mapGetters } from 'vuex';
import endpoints from "@api/repository";
import moment from 'moment';
import Helper from "@utils/misc";

export default {
    name: 'InventoryItems',
    data(){
        return{
            moment: moment,
            snackbar: {
                visible: false,
                text: "",
            },
            search: "",
            options:{},
            pagination: {
                totalCount: 0,
                url: endpoints.storeItem + "?store_id="+ this.$route.params.store_id, 
            },
            store_item_headers:[
                { text: "Item Code", value: "code", align: "center", sortable: false },
                { text: "Item Name", value: "item_name", sortable: false },
                { text: "Last Arrived", value: "arrived_on", align: "center", sortable: false },
                // { text: "Store", value: "store.store_name", align: "center", sortable: false },
                // { text: "Category", value: "store.store_category", align: "center", sortable: false },
                // { text: "Type", value: "store.store_type", align: "center", sortable: false },
                { text: "Batch No.", value: "batch_number", align: "center", sortable: false },
                { text: "Quantity", value: "quantity", align: "center", sortable: false },
                { text: "Unit Price", value: "unit_price", align: "center", sortable: false },
            
            ],
            store_items : [],
            store: {
                id: null,
                code: null,
                store_name: null,
                invoice_prefix: null,
                store_type: {
                    id: null,
                    code: null,
                    type_name: null,
                },
                store_category: {
                    id: null,
                    code: null,
                    category_name: null,
                },
                store_items: []
            },  
        };
    },
    computed: {
        ...mapGetters(["currentUser", "accessToken", "isLoading"]),
        essentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },
    },
    methods: {
        ...mapActions(["setLoading"]),
        async getAllStoreItems(){
            var response;
            var url = this.pagination.url;
            if(this.search){
                url += (url.split("?")[1] ? "&" : "?") + "query=" + this.search;
            }
            response = await api.call(this.essentials, url)

            if(response){
                this.store_items = response.results;
                this.pagination.totalCount = response.count;
                this.pagination.nextUrl = response.next;
            }
        },

        async getStoreDetails(){
            var url = endpoints.stores + this.$route.params.store_id + "/";
            this.store = await api.call(this.essentials, url);
        },

        // handles api errors
        async handleApiErrors(err) {
            this.setLoading(false);
            if (err.response) {
                console.log(err.response);
            } else {
                this.snackbar.text = "Unknown error occurred";
                this.snackbar.visible = true;
            }
        },

        currencyFormat(amount){
            return Helper.currencyFormat(amount);
        },

        clickStoreItemRow(value){
            this.$router.push({ name: 'StoreItemDetails', params:{ store_id: this.$route.params.store_id, item_id: value.id } })
        }
    },
    watch: {
        search: {
            async handler() {
                this.options.page = 1;
                var searched = this.search;
                var self = this;
                setTimeout(function () {
                    if (searched == self.search) {
                        self.getAllInventoryItems();
                    }
                }, 500);
            },
        }
    },
    created(){
        this.getStoreDetails();
        this.getAllStoreItems();
    }
}
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>